import DropBankPanel from '../../../../assets/svg/utils/panels/drop-bank-panel.svg';
import Button from '../../../../Components/Button';
import useConnectWallet from '../../../../hooks/useConnectWallet';

function Wallet() {
  const { onConnect, disconnectWallet, walletAddress } = useConnectWallet();

  const onCopy = (address: string) => {
    navigator.clipboard.writeText(address);
  };

  if (walletAddress) {
    return (
      <div className="mx-auto w-fit flex flex-col items-center font-Bangers pt-[18px]">
        <img src={DropBankPanel} alt="drop-bank-panel" width={317} className="absolute z-[-1] top-0" />
        <span className="text-lg leading-[19px]">Wallet connected</span>
        <span className="text-[#B5C4FC] text-[10px] leading-[12px] font-Inria pt-1">{walletAddress}</span>
        <div className="flex gap-2 mt-2.5">
          <Button className="btn neutral py-2 w-[109px] text-base" pureClass onClick={onConnect}>Edit</Button>
          <Button className="btn neutral py-2 w-[109px] text-base" pureClass onClick={() => onCopy(walletAddress)}>Copy</Button>
          <Button className="btn neutral py-2 w-[109px] text-base" pureClass onClick={disconnectWallet}>Disconnect</Button>
        </div>
      </div>
    );
  }

  return (
    <Button
      className="
        btn navy
        py-4
        text-[24px]
      "
      onClick={onConnect}
    >
      Connect wallet
    </Button>
  );
}

export default Wallet;
